import type { Tela1ViewModel } from './tela1-adapter';

export interface ScenarioBannerProps {
  vm: Tela1ViewModel;
  p1Active: number;
  hasOverloadedAttendant: boolean;
  onNavigate?: (target: string) => void;
}

export function ScenarioBanner({
  vm,
  p1Active,
  hasOverloadedAttendant,
  onNavigate,
}: ScenarioBannerProps): React.JSX.Element | null {
  const conflicts = vm.priorityQueue.conflictAlerts ?? [];
  const firstCritical = conflicts.find((a) => a.severity === 'critical');

  // Priority 1 — conflict alert CRITICAL
  if (firstCritical !== undefined) {
    return (
      <div className="banner banner--danger">
        <span className="banner__icon" aria-hidden="true">
          🚨
        </span>
        <div className="banner__body">
          <span className="banner__title">Conflict Alert CRITICAL — ação imediata necessária</span>
          <span className="banner__sub">{firstCritical.summary}</span>
        </div>
        <button
          type="button"
          className="btn-ghost-mini banner__action"
          onClick={() => {
            onNavigate?.('centro-alertas');
          }}
        >
          Ir para Centro
        </button>
      </div>
    );
  }

  // Priority 2 — p1Active >= 5
  if (p1Active >= 5) {
    return (
      <div className="banner banner--danger">
        <span className="banner__icon" aria-hidden="true">
          🔴
        </span>
        <div className="banner__body">
          <span className="banner__title">Incidente em curso</span>
          <span className="banner__sub">
            {p1Active} conversas em P1 — runbook de incidente massivo recomendado
          </span>
        </div>
        <button
          type="button"
          className="btn-ghost-mini banner__action"
          onClick={() => {
            onNavigate?.('painel-p1');
          }}
        >
          Abrir Painel P1
        </button>
      </div>
    );
  }

  // Priority 3 — overloaded attendant
  if (hasOverloadedAttendant === true) {
    return (
      <div className="banner banner--warn">
        <span className="banner__icon" aria-hidden="true">
          ⚠
        </span>
        <div className="banner__body">
          <span className="banner__title">Volume elevado de conversas</span>
          <span className="banner__sub">considere redistribuir; reforço sugerido</span>
        </div>
      </div>
    );
  }

  return null;
}
